import React from "react";
import { View } from "ui/atoms/view";
import { Text, Pressable } from "react-native";
import {
  QuestionTypeDescriptionMapping,
  QuestionTypeEditListing,
  QuestionTypeEnum,
} from "app/services/api/types/forms/enums/QuestionTypeEnum";

interface Props {
  onPickType: (type: QuestionTypeEnum) => void;
}

export function QuestionTypeSelectionMolecule({ onPickType }: Props) {
  return (
    <View className="gap-5">
      {QuestionTypeEditListing.map(({ section, types }) => (
        <View key={section}>
          <Text className="text-lg font-semibold mb-2">{section}</Text>
          <View className="grid md:grid-cols-2 gap-3">
            {types.map((type) => (
              <Pressable
                key={type}
                onPress={() => onPickType(type)}
                className="border border-background-300 rounded-lg p-3 active:bg-background-50 data-[hover=true]:border-outline-400"
              >
                <Text className="text-base font-semibold text-primary-900">
                  {QuestionTypeDescriptionMapping[type].short}
                </Text>
                <Text className="text-sm text-gray-600">
                  {QuestionTypeDescriptionMapping[type].decription}
                </Text>
              </Pressable>
            ))}
          </View>
        </View>
      ))}
    </View>
  );
}
